
import { defineComponent, PropType } from 'vue'
import { ReportSortT } from '~/types/reportTypes'

export interface SortChoice {
  name: string
  label: string
  icon: string
}

/**
 * Component to sort issues based on inc & dec priority.
 */
export default defineComponent({
  name: 'PublicReportSort',
  model: {
    prop: 'selectedSortFilter',
    event: 'updateSortFilter'
  },
  props: {
    selectedSortFilter: {
      type: String as PropType<ReportSortT>,
      required: true
    },
    buttonType: {
      type: String,
      default: 'secondary'
    }
  },
  computed: {
    modelValue: {
      get(): ReportSortT {
        return this.selectedSortFilter
      },
      set(value: ReportSortT) {
        this.$emit('updateSortFilter', value)
      }
    },
    sortFilters(): Record<ReportSortT, SortChoice> {
      return {
        'first-created': { label: 'First created', icon: 'first-seen', name: 'first-created' },
        'last-created': { label: 'Last created', icon: 'last-seen', name: 'last-created' }
      }
    },
    sortApplied(): boolean {
      return Boolean(this.modelValue)
    },

    filterLabel(): string {
      const filterItem = this.sortFilters[this.modelValue]
      return filterItem.label
    },

    filterIcon(): string {
      return this.sortFilters[this.modelValue]?.icon
    }
  },
  methods: {
    toReportSortT(value: string): ReportSortT {
      // TODO: get rid of this after migration
      return value as ReportSortT
    }
  }
})
